import React, { useState } from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
// @ts-ignore
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import api from '~/services';
import { log } from '~/helpers';
import { recoverPasswordSchema } from '~/validations/form';
import * as lib from '~/dependencies';
import * as AuthStyles from '../Auth/styles';
import * as AuthComponents from '../Auth/components';

export default function RecoverPassword() {
  const [formErrors, setFormErrors] = useState([]);
  const [recoverEmail, setRecoverEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const appVersion = useSelector(
    (state: RootStateOrAny) => state.system?.version
  );

  const history = useHistory();
  const { t } = lib.useTranslation();

  async function sendRecoverPasswordEmail() {
    lib.ToastMessage(false);

    try {
      const response = await api.users.post.recoverPassword(
        encodeURIComponent(recoverEmail)
      );

      if (
        response.data?.message === 'We are sorry but your email is not active.'
      ) {
        // FIXME: (Legacy) add translation keys in such case
        lib.ToastMessage('error', response.data?.message, 7000);
      } else {
        lib.ToastMessage(
          'success',
          t('screens.auth.recoverPass.success'),
          5000
        );
      }
      setLoading(false);
    } catch (err) {
      log.error('Failed to send recover password email.', err);
      lib.ToastMessage(
        'error',
        t('validations.messagesNotifications.auth.password.reset.error')
      );
    }
  }

  async function validateForm() {
    try {
      setLoading(true);

      await recoverPasswordSchema.validate(
        {
          recoverEmail,
        },
        { abortEarly: false }
      );

      await sendRecoverPasswordEmail();
    } catch (err) {
      const error = err as Yup.ValidationError;
      const result = error.inner.map(
        (e: { path: string; message: string }) => ({
          field: e.path,
          message: e.message,
        })
      );
      setFormErrors(result);
      setLoading(false);
    }
  }

  function onSubmit(e: any) {
    e.preventDefault();
  }

  function onGoBack() {
    history.push('/auth');
  }

  function onInputKeyPress(event: { key: string }) {
    if (event.key === 'Enter') {
      validateForm();
    }
  }

  return (
    <div id="contentNuacom">
      <div id="mainContent">
        <AuthStyles.BackgroundFloat />
        <form onSubmit={onSubmit}>
          <AuthStyles.BoxLogin>
            <AuthComponents.LogoAuth />
            <>
              {/* @ts-ignore FIXME: (Legacy) Missing Password Props */}
              <AuthComponents.InputLogin
                data-test-id="recover-pass"
                name="recoverEmail"
                label={t('screens.auth.recoverPass.email.label')}
                value={recoverEmail}
                onChange={(data: { value: string }) =>
                  setRecoverEmail(data.value.trim())
                }
                placeholder={t('screens.auth.recoverPass.email.placeholder')}
                validator={formErrors}
                loading={loading}
                onKeyPress={onInputKeyPress}
              />
              <AuthStyles.Space height={25} />
              <AuthComponents.SubmitLogin
                data-test-id="btn-reset"
                onSubmit={validateForm}
                loading={loading}
                title={t('screens.auth.recoverPass.btnResetPass')}
                disabled={!recoverEmail}
                onKeyPress={onInputKeyPress}
              />
              <AuthStyles.Space height={20} />
              <span
                className="forgot-password-link-back"
                role="presentation"
                onClick={onGoBack}>
                {t('screens.auth.recoverPass.back')}
              </span>
            </>
          </AuthStyles.BoxLogin>
        </form>
        <AuthStyles.Version>{`v${appVersion}`}</AuthStyles.Version>
      </div>
    </div>
  );
}
